import { useAuth } from '@/lib/AuthContext';
import { Loader2 } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children, allowPasswordChange = false, requireOwner = false }) {
  const { admin, loading, mustChangePassword, checkAuth } = useAuth();
  const [checkingKey, setCheckingKey] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      await checkAuth();
      setCheckingKey(false);
    };

    initAuth();
  }, []);

  if (loading || checkingKey) {
    return (
      <div className="min-h-screen bg-[#020617] flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-8 h-8 text-[#22c55e] animate-spin mx-auto mb-4" />
          <p className="text-slate-400">Se verifică autentificarea...</p>
        </div>
      </div>
    );
  }

  if (!admin) {
    return <Navigate to="/admin/login" replace />;
  }

  // If must change password and not on the change password page, redirect
  if (mustChangePassword && !allowPasswordChange) {
    return <Navigate to="/admin/change-password" replace />;
  }

  // Check if OWNER role is required (accept both "owner" and "admin" for backward compatibility)
  if (requireOwner && admin.role !== 'owner' && admin.role !== 'admin') {
    return <Navigate to="/admin" replace />;
  }

  return children;
}
